import React from 'react'
import { Card } from '../ui/Card'

export interface KpiCardProps {
  id: string
  label: string
  value: string
  sub?: string
  icon: React.ReactNode
  accent?: string
  loading?: boolean
  editMode?: boolean
  dragHandleProps?: React.HTMLAttributes<HTMLDivElement>
}

export function KpiCard({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  id: _id, label, value, sub, icon, accent = '#4f46e5', loading, editMode, dragHandleProps,
}: KpiCardProps) {
  return (
    <Card
      padding="md"
      style={editMode ? {
        border: `1.5px dashed ${accent}`,
        background: accent + '0a', // alpha 4% — assumes 6-digit hex accent
      } : undefined}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 12, fontWeight: 500, color: '#64748b', marginBottom: 6 }}>{label}</div>
          {loading ? (
            <div style={{ height: 32, width: 80, background: '#f1f5f9', borderRadius: 6 }} />
          ) : (
            <div style={{ fontSize: 28, fontWeight: 700, color: '#0f172a', lineHeight: 1 }}>{value}</div>
          )}
          {sub && !loading && (
            <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>{sub}</div>
          )}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          {editMode && (
            <div
              role="button"
              aria-label="Flyt kort"
              {...dragHandleProps}
              style={{
                color: accent,
                fontSize: 16,
                cursor: 'grab',
                userSelect: 'none',
                padding: '2px 4px',
              }}
            >
              ⠿
            </div>
          )}
          <div style={{
            width: 38,
            height: 38,
            borderRadius: 10,
            background: accent + '18', // alpha 9% — assumes 6-digit hex accent
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: accent,
            flexShrink: 0,
          }}>
            {icon}
          </div>
        </div>
      </div>
    </Card>
  )
}
